import { InternalCredentialsList } from "@/features/internal-credentials";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../../../httpClient";
import { getTenant } from "../../../../../requests/getTenant";

export const Route = createFileRoute(
  "/dashboard/tenants/$tenantId/internal-credentials/",
)({
  component: InternalCredentialsList,
  head: () => ({
    meta: [{ title: "Credenciais internas - Backoffice Detentora Iniciador" }],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context, params }) => {
    const tenantId = decodeURIComponent(params.tenantId);

    const [_, tenant] = await Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: ["internal-credentials", tenantId],
        queryFn: async () => {
          const httpClient = isomorphicHttpClient();

          const { data, error } = await httpClient.GET(
            "/v1/internal/credentials/{tenantId}",
            {
              params: { path: { tenantId } },
            },
          );

          if (error) {
            throw new Error(error.message);
          }

          return data;
        },
      }),

      context.queryClient.fetchQuery({
        queryKey: ["tenant", tenantId],
        queryFn: () => getTenant(tenantId),
      }),
    ]);

    return tenant.tenantName;
  },
});
